import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    ID: 'product.property.id',
    LANGUAGE_ID: 'product.property.languageid',
    VALUE: 'product.property.value',
    TYPE: 'product.property.type',
  },
}

export const TYPES = {
  ENTITY_ID: 'EntityId',
  ITEM_EAN_CODE: 'ItemEANCode',
  ITEM_MODEL_NUMBER: 'ItemModelNumber',
  ITEM_SEQUENCE: 'ItemSequence',
  ITEM_UNIQUE_ID: 'ItemUniqueId',
  PRODUCT_MODEL_NUMBER: 'ProductModelNumber',
  PRODUCT_SEQUENCE: 'ProductSequence',
  PRODUCT_BRAND: 'ProductBrand',
  ITEM_BRAND: 'ItemBrand',
  PRODUCT_NAME_INTERNAL: 'ProductNameInternal',
  PRODUCT_VARIANTS_OUTLET: 'ProductVariantsOutlet',
  PRODUCT_VARIANTS_CURRENT: 'ProductVariantsCurrent',
  ARCHIVE_ITEM: 'ArchiveItem',
}

export const GROUP = {
  PRODUCT_VARIANTS: [
    TYPES.PRODUCT_VARIANTS_CURRENT,
    TYPES.PRODUCT_VARIANTS_OUTLET,
    TYPES.ARCHIVE_ITEM,
  ],
}

export const PATHS = {
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  LANGUAGE_ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LANGUAGE_ID],
  VALUE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.VALUE],
  TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TYPE],
}

export default {
  ...CONSTANTS,
  PATHS,
  TYPES,
  GROUP,
}
